import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FormBuscaEndereco from '~/compositions/FormBuscaEndereco';
import Header from '~/compositions/Header';
import { Container as DefaultContainer } from '~/pages/common';
import {
  PageContainer,
  FormContainer,
  TitleContainer,
  Title,
  BackIcon,
  Description,
  Container,
} from './commonStyles';
import Loader from '~/components/Loader';
import { BreadcrumbsContext } from '~/providers/BreadcrumbsProvider';

const Subtitle = styled.h4`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1rem !important;
  font-weight: 500;
  margin-bottom: 10px;
`;

const SubContainer = styled.div`
  margin-bottom: 5rem;
  margin-top: 2.66rem;
`;

function BuscaEndereco() {
  const history = useHistory();
  const breadcrumbs = useContext(BreadcrumbsContext);
  const isLoading = useSelector(state => state.loading);

  function setBreadcrumb(icon, label) {
    breadcrumbs.setBreadcrumb({
      icon,
      label,
    });
  }

  useEffect(() => {
    setBreadcrumb('store', 'Indique um estabelecimento');
    return () => setBreadcrumb();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Container>
        <Header />
      </Container>
      <PageContainer>
        <DefaultContainer fullWidth>
          <Loader isLoading={isLoading}>
            <FormContainer data-testid="test-container">
              <TitleContainer>
                <BackIcon
                  onClick={() => history.goBack()}
                  icon={['fas', 'chevron-left']}
                />
                <Title>Indique um estabelecimento</Title>
              </TitleContainer>
              <Description>
                Insira os dados abaixo e indique um estabelecimento para fazer
                parte da nossa rede credenciada. Não esqueça de selecionar quais
                tipos de cartão você deseja utilizar e o tipo de estabelecimento
                que está cadastrando.
              </Description>
              <SubContainer>
                <Subtitle>Dados do Estabelecimento</Subtitle>
                <FormBuscaEndereco />
              </SubContainer>
            </FormContainer>
          </Loader>
        </DefaultContainer>
      </PageContainer>
    </>
  );
}

export default BuscaEndereco;
